document.addEventListener("DOMContentLoaded", function () {
    // Elemente auswählen
    const svgPrint = document.getElementById("svg-path");
    const variantContainer = document.getElementById("mw-product-variants");
    const variantSelect = variantContainer.querySelector("select.product-variant-container");
    const popularSizeItems = document.querySelectorAll(".poular-size_item");

    // Funktion zum Extrahieren der Dimensionen aus dem Variantentitel
    function extractDimensions(variantTitle) {
        let match = variantTitle.match(/(\d+[.,]?\d*)\s*(?:cm|CM)\s*(?:x|X|×)\s*(\d+[.,]?\d*)\s*(?:cm|CM)/);
        if (match) {
            const width = parseFloat(match[1].replace(',', '.'));
            const height = parseFloat(match[2].replace(',', '.'));
            return {
                width: width,
                height: height
            };
        }
        return null;
    }

    // Funktion zum Generieren der beliebten Größen
    function generatePopularSizes() {
        if (!variantSelect || variantSelect.options.length === 0 || !svgPrint) return;

        // Aspektverhältnis des SVG berechnen
        const aspectRatio = svgPrint.clientWidth / svgPrint.clientHeight;
        if (!aspectRatio || aspectRatio <= 0) return;

        // Extrahiere Dimensionen aus allen Varianten
        const variants = Array.from(variantSelect.options).map(option => {
            const dimensions = extractDimensions(option.text);
            return dimensions ? dimensions : null;
        }).filter(v => v);
        
        // Sortiere Varianten nach Höhe
        variants.sort((a, b) => a.height - b.height);
        
        if (variants.length === 0) return;
        
        // Kleinste Variante als Ausgangspunkt nehmen
        const smallestVariant = variants[0];
        
        // Minimale Höhe aus der kleinsten Variante
        const minHeight = smallestVariant.height;
        
        // Prüfe, ob das SVG-Aspektverhältnis zu einer zu niedrigen Höhe führen würde
        // Wenn ja, berechne die Mindestbreite, die erforderlich ist, um die Mindesthöhe zu erreichen
        const minRequiredWidth = minHeight * aspectRatio;
        
        // Starte mit einer Breite, die die Mindesthöhe respektiert
        const baseWidth = Math.max(Math.ceil(minRequiredWidth / 10) * 10, Math.ceil(smallestVariant.width / 10) * 10);
        
        // Generiere drei beliebte Größen mit 10er-Schritten für die Breite
        const firstWidth = baseWidth;
        const secondWidth = firstWidth + 20; // 20cm größer
        const thirdWidth = secondWidth + 20; // 40cm größer als der erste
        
        // Berechne die entsprechenden Höhen basierend auf dem Aspektverhältnis des SVG
        // und stelle sicher, dass sie nicht unter der Mindesthöhe liegen
        const sizes = [
            {
                width: firstWidth,
                height: Math.max(firstWidth / aspectRatio, minHeight)
            },
            {
                width: secondWidth,
                height: Math.max(secondWidth / aspectRatio, minHeight)
            },
            {
                width: thirdWidth,
                height: Math.max(thirdWidth / aspectRatio, minHeight)
            }
        ];
        
        // Setze die berechneten Größen in die popularSizeItems
        sizes.forEach((size, index) => {
            if (index < popularSizeItems.length) {
                const sizeText = `${size.width.toFixed(0)} cm x ${size.height.toFixed(1)} cm`;
                popularSizeItems[index].querySelector("span").textContent = sizeText;
            }
        });
    }

    // Event-Listener für Klicks auf die beliebten Größen
    popularSizeItems.forEach(item => {
        item.addEventListener("click", function() {
            const sizeText = this.querySelector("span").textContent;
            const dimensions = extractDimensions(sizeText);
            
            if (dimensions) {
                // Setze die Werte in die Eingabefelder
                const svgWidthInput = document.getElementById("svgWidth");
                const svgHeightInput = document.getElementById("svgHeight");
                
                if (svgWidthInput && svgHeightInput) {
                    svgWidthInput.value = dimensions.width.toFixed(1);
                    svgHeightInput.value = dimensions.height.toFixed(1);
                    
                    // Simuliere ein Eingabeereignis für die Breite
                    const event = new Event('input', { bubbles: true });
                    svgWidthInput.dispatchEvent(event);
                }
                
                // Visuelles Feedback
                popularSizeItems.forEach(el => el.classList.remove("active"));
                this.classList.add("active");
            }
        });
    });

    // Beobachte Änderungen am SVG und aktualisiere die beliebten Größen
    const svgObserver = new MutationObserver(() => {
        generatePopularSizes();
    });
    
    if (svgPrint) {
        svgObserver.observe(svgPrint, { attributes: true, childList: true, subtree: true });
    }

    // Beobachte den Varianten-Container und generiere die beliebten Größen neu, wenn sich die Varianten ändern
    const variantObserver = new MutationObserver(() => {
        generatePopularSizes();
    });
    
    if (variantContainer) {
        variantObserver.observe(variantContainer, { attributes: true, childList: true, subtree: true });
    }

    // Generiere die beliebten Größen beim Laden der Seite
    // Wir verzögern den Aufruf leicht, um sicherzustellen, dass das SVG vollständig geladen ist
    setTimeout(generatePopularSizes, 500);
});